import React from 'react';
import { useMutation } from '@apollo/client';
import { RESTORE_DELETED_BINDER } from '../../../../../../api/queries/queries_local';
import { Checkbox, TextElement, toast } from '@ibinder/ui-common-core';
import { TENANT_HEADER } from '@ibinder/common-utils';
import styled from 'styled-components';
import { ModalFooter, StandardModal } from '@ibinder/ui-common-dialogs';

const ModalContent = styled.div`
  padding: 1rem;
`;

const ConfirmRestoreBinderModal = ({ onClose, onAfterClose, data }) => {
  const [removeParticipants, setRemoveParticipants] =
    React.useState<boolean>(false);

  const [restoreDeletedBinder] = useMutation(RESTORE_DELETED_BINDER, {
    variables: {
      binderId: data.binder.id,
      removeAllParticipantsFromBinder: removeParticipants,
      body: {} // required in mutations
    },
    context: {
      headers: TENANT_HEADER(data.organizationId)
    },
    onCompleted: ({ restoreDeletedBinder: response }) => {
      if (response?.binder?.id) {
        toast.success(`Successfully restored binder ${response.binder.name}`);
        onAfterClose();
      } else {
        // apollo doesnt trigger onError for some reason https://github.com/apollographql/apollo-client/issues/5708 (old issue)
        // If response is empty we assume it failed
        toast.error(`Failed to restore binder ${data.binder.name}`);
      }
    }
  });

  return (
    <StandardModal
      open
      headerText="Restore binder"
      modalContainer="modalcontainer"
      footer={
        <ModalFooter
          onCreateText="Restore binder"
          onCreate={() => {
            restoreDeletedBinder();
            onClose();
          }}
          onCancel={onClose}
          onCancelText="Cancel"
        />
      }
    >
      <ModalContent>
        <TextElement color="dark">
          Do you want to restore {data.binder.name} with binder id{' '}
          {data.binder.id}?
        </TextElement>
        <Checkbox
          checked={removeParticipants}
          label="(Optional) Remove all participants from binder"
          onChange={({ target }) => setRemoveParticipants(target.checked)}
        />
      </ModalContent>
    </StandardModal>
  );
};

export default ConfirmRestoreBinderModal;
